import { render, staticRenderFns } from "./NotificationsPanel.vue?vue&type=template&id=e66bb11c&"
import script from "./NotificationsPanel.vue?vue&type=script&lang=js&"
export * from "./NotificationsPanel.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports